import React, { Component } from 'react';
import { connect } from 'react-redux';

import { hideMap } from 'actions/map';
import { setTab } from 'actions/subtabs';
import Loading from 'components/Loading';

import StoryletsComponent from 'components/StoryletsAvailable/StoryletsAvailableComponent';
import { IStorylet, StoryletPhase } from "types/storylet";
import { IAppState } from "types/app";
import { StoryletActiveTab as ActiveTab } from "types/subtabs";

class StoryletsAvailableContainer extends Component<Props> {
  static displayName = 'StoryletsAvailableContainer';

  static defaultProps = {
    storylets: undefined,
  };

  switchTab = (subtab: ActiveTab) => {
    const { dispatch, isMapVisible } = this.props;
    dispatch(setTab({ subtab, tab: 'storylet' }));

    // If we're switching to the 'sometimes' subtab, then hide the map
    if (subtab === 'sometimes' && isMapVisible) {
      dispatch(hideMap());
    }
  };

  /**
   * render
   * @return {Object}
   */
  render() {
    const { showOps, storylets, subtab } = this.props;

    if (!storylets) {
      return <Loading spinner />;
    }

    return (
      <StoryletsComponent
        onTabSwitch={this.switchTab}
        showOps={showOps}
        subtab={subtab}
      />
    );
  }
}

interface Props {
  dispatch: Function,
  isMapVisible: boolean,
  phase: StoryletPhase,
  showOps: boolean,
  storylets?: IStorylet[] | null,
  subtab: ActiveTab,
}

const mapStateToProps = ({
  map: { isVisible, showOps },
  storylet: { phase, storylets },
  subtabs: { storylet: subtab },
}: IAppState) => ({
  phase,
  showOps,
  storylets,
  subtab,
  isMapVisible: isVisible,
});

export default connect(mapStateToProps)(StoryletsAvailableContainer);
